function EktarIframeBanner({ className, ...props }) {
    return <div id='ek_single_banner_iframe' className={`${className || ''}`}/>;
}

export default EktarIframeBanner;